/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const currentVerificationChallengesResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const currentVerificationChallengesResponseOutputItemsItemContactIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const currentVerificationChallengesResponseOutputItemsItemExpiresAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const currentVerificationChallengesResponseOutputItemsItemFailedAttemptsMin = 0;
export const currentVerificationChallengesResponseOutputItemsItemFailedAttemptsMax = 9007199254740991;

export const currentVerificationChallengesResponseOutputItemsItemMaxAttemptsExclusiveMin = 0;
export const currentVerificationChallengesResponseOutputItemsItemMaxAttemptsMax = 9007199254740991;

export const currentVerificationChallengesResponseOutputItemsMax = 10;

export const CurrentVerificationChallengesResponseOutput = zod.object({
  items: zod
    .array(
      zod.object({
        id: zod.uuid().regex(currentVerificationChallengesResponseOutputItemsItemIdRegExp),
        contactId: zod
          .uuid()
          .regex(currentVerificationChallengesResponseOutputItemsItemContactIdRegExp),
        transport: zod.enum(['email-link', 'sms-code', 'voice-code']),
        state: zod.enum(['pending', 'consumed', 'superseded', 'expired', 'locked', 'canceled']),
        expiresAt: zod.iso
          .datetime({ offset: true })
          .regex(currentVerificationChallengesResponseOutputItemsItemExpiresAtRegExp),
        failedAttempts: zod
          .int()
          .min(currentVerificationChallengesResponseOutputItemsItemFailedAttemptsMin)
          .max(currentVerificationChallengesResponseOutputItemsItemFailedAttemptsMax),
        maxAttempts: zod
          .int()
          .gt(currentVerificationChallengesResponseOutputItemsItemMaxAttemptsExclusiveMin)
          .max(currentVerificationChallengesResponseOutputItemsItemMaxAttemptsMax),
      }),
    )
    .max(currentVerificationChallengesResponseOutputItemsMax),
});

export type CurrentVerificationChallengesResponseOutput = zod.input<
  typeof CurrentVerificationChallengesResponseOutput
>;
export type CurrentVerificationChallengesResponseOutputOutput = zod.output<
  typeof CurrentVerificationChallengesResponseOutput
>;
